import { Dispatch } from "react";
import { IAction, IApiService } from "..";

export interface AsyncActionsParams {
  dispatch: Dispatch<IAction>;
  api: IApiService;
}

type Processes<Descendant> = Partial<Record<keyType<Descendant>, AbortController>>;

type keyType<Descendant> = keyof Descendant | string; // Should be specific sting:  keyof Descendant + _id - ts issue

export class AsyncActions<Descendant = unknown> {
  protected readonly dispatch: Dispatch<IAction>;
  protected readonly api: IApiService;
  protected processes: Processes<Descendant>;
  constructor({ dispatch, api }: AsyncActionsParams) {
    this.dispatch = dispatch;
    this.api = api;
    this.processes = {};
  }

  protected addProcess = (name: keyType<Descendant>): AbortController => {
    const process = this.processes[name];

    if (process) {
      process.abort();
      delete this.processes[name];
    }

    const abortController = new AbortController();
    this.processes[name] = abortController;
    return abortController;
  };

  protected removeProcess = (name: keyType<Descendant>) => {
    delete this.processes[name];
  };
}
